import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { paths } from '@/routes/paths';
import type { GlobalRole } from '@/auth/permissions.types';

export function useHomeNavigation() {
  const navigate = useNavigate();

  const navigateToHome = useCallback(
    (globalRoles: GlobalRole[] = []) => {
      if (globalRoles.includes('HR') || globalRoles.includes('Staffing')) {
        navigate(paths.staffingActivities.occerSearch);
      } else {
        navigate(paths.dashboard);
      }
    },
    [navigate]
  );

  return { navigateToHome };
}
